export default __webpack_public_path__ + "6e303c14489ec36acc22f9d747d2cb46.png";